import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { useLocalStorage } from "../../hooks";
import * as dashboardActions from "../../redux/reducers/dashboardReducer";
import { dashboardState } from "../../redux/reducers/dashboardReducer";
import * as userActions from "../../redux/reducers/userReducer";

import GeneralTab from "./action/GeneralTab";
import PoliciesTab from "./action/PoliciesTab";
import PricingTab from "./action/PricingTab";
import ScheduleTab from "./action/schedule/ScheduleTab";

import { minutesToDuration } from "../../helpers";

import defaultImage from "../..//assets/defaultImage.svg";
import clock_png from "../../assets/Clock.png";
import payment from "../../assets/Payment.svg";
import copy_squares from "../../assets/square.on.square.svg";
import greenlocation from "../../assets/greenlocation.svg";
import greentime from "../../assets/greentime.svg";
import {
  TwButton,
  TwContainer,
  TwMainLayout,
  TwRating,
} from "../../components/tailwind";
import TwDrawer from "../../components/tailwind/TwDrawer";
import { useToast } from "../../provider/ToastProvider";
import {
  setActionLoading,
  setGlobalLoading,
} from "../../redux/reducers/loadingReducer";
import { userState } from "../../redux/reducers/userReducer";
import axiosInstance from "../../utils/axiosInstance";
import { getUrlForEvent, getUrlForUsers } from "../../utils/confighelpers";
import AddonsTab from "./action/AddonsTab";
import StatBox from "./view/StatBox";
import { format, parseISO } from "date-fns";
import EditPencilIcon from "../../assets/icons/EditPencilIcon";
import ChangeLocationModal from "../../components/ChangeLocationModal";
import ChangeDateTimeModal from "../../components/ChangeDateTimeModal";
import moment from "moment";
import SalesChannleTab from "./action/SalesChannleTab";
import { useTranslation } from "react-i18next";

export default function EventDetails({ navigation, profileFor }) {
  const { t, i18n } = useTranslation();
  const { addToast, addSuccessToast, addErrorToast } = useToast();
  const [userToken] = useLocalStorage("userToken");
  if (userToken === undefined || userToken == "") {
    window.location.href = "/";
  }
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const dashboardReduxState = useSelector(dashboardState);
  const userReduxState = useSelector(userState);
  const [tabCurrentState, setTabCurrentState] = React.useState("1");

  if (!userToken || userToken.length < 1) {
    navigate("/", { replace: true });
  }

  // const title = " Add New " + (location.state ? location.state.title : "")
  const title =
    ` ${t("inputFieldsTitle.edit")} ` +
    profileFor.toLowerCase().replace(/\b[a-z]/g, function (letter) {
      return letter.toUpperCase();
    });
  const handleTabChange = (event, newValue) => {
    setTabCurrentState(newValue);
  };

  const handleFormValueChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };

  // const sessionDataToDisplay = dashboardReduxState.calendarSessionData;
  const sessionDataToDisplay = dashboardReduxState.eventScheduleData;
  const eventInfo = dashboardReduxState.eventData;
  const edit = null;
  const editData = {};
  const durationObj = minutesToDuration(eventInfo.duration);
  const classBodyData = {
    eventId: eventInfo._id,
    photo: eventInfo.eventPhoto,
    eventCategory: eventInfo.eventCategory
      ? { _id: eventInfo.eventCategory, name: "" }
      : {},
    categories: eventInfo.catId ? { _id: eventInfo.catId, catName: "" } : {},
    eventName: eventInfo.eventName,
    tagLine: eventInfo.tagLines,
    classDescription: eventInfo.description,
    duration: durationObj,
    durationstring: `${durationObj.hours} hr ${durationObj.mins} min`,
    sessions: "",
    whatToCarry: eventInfo.whatToCarry,
    freeCancellation: eventInfo.eventCancelationPolicy?.isEnabled
      ? true
      : false,
    cancellationPeriod:
      eventInfo.eventCancelationPolicy?.minutes === 60
        ? "1hr"
        : eventInfo.eventCancelationPolicy?.minutes === 1440
          ? "24hrs"
          : eventInfo.eventCancelationPolicy?.minutes === 2880
            ? "48hrs"
            : eventInfo.eventCancelationPolicy?.minutes === 10080
              ? "1 week"
              : "",
    cancellationCharge:
      eventInfo.eventCancelationPolicy?.isEnabled == true &&
      eventInfo.eventCancelationPolicy?.cancellationCharge != undefined
        ? eventInfo.eventCancelationPolicy?.cancellationCharge
        : 0,
    inviteCodeOnlyBooking: eventInfo.isPrivate ? true : false,
    maxTicketsPerOrder: eventInfo.maxTicketsPerOrder
      ? eventInfo.maxTicketsPerOrder
      : 10,
    paymentAtVenue: eventInfo.paymentAtVenue ? eventInfo.paymentAtVenue : false,
    // eventPricingList: eventInfo.eventPricingList ? eventInfo.eventPricingList : [],
    // addonsPricingList: eventInfo.addonsPricingList ? eventInfo.addonsPricingList : [],
    eventPricingList: sessionDataToDisplay.eventPricingList
      ? sessionDataToDisplay.eventPricingList
      : [],
    addonsPricingList: sessionDataToDisplay.addonsPricingList
      ? sessionDataToDisplay.addonsPricingList
      : [],
  };
  const [formValues, setFormValues] = React.useState(classBodyData);
  const [formScheduleValues, setFormScheduleValues] = React.useState({});
  const [defaultScheduleData, setDefaultScheduleData] = React.useState({});
  const [isSubmitting, setSubmitting] = React.useState(false);
  const [formErrors, setFormErrors] = React.useState({});
  const [showGeneralDrawer, setShowGeneralDrawer] = React.useState(false);
  const [showPoliciesDrawer, setShowPoliciesDrawer] = React.useState(false);
  const [isDescExpanded, setDescExpanded] = React.useState(false);
  const [isWhatToCarryExpanded, setWhatToCarryExpanded] = React.useState(false);
  const [dateTimeModalOpen, setDateTimeModalOpen] = React.useState(false);
  const [locationModalOpen, setLocationModalOpen] = React.useState(false);
  const [popoverOptionsDisabled, setPopoverOptionsDisabled] =
    React.useState(false);

  const appUrl = eventInfo?.appUrl
    ? eventInfo?.appUrl
    : process.env.REACT_APP_WEBAPP_EVENT_URL;
  const bookingLink =
    appUrl + (eventInfo?.bookingLink ? eventInfo?.bookingLink : "");

  const defaultDataSaveProgress = {
    isStartSubmiting: false,
    isButtonShow: true,
  };
  const [dataSaveProgress, setDataSaveProgress] = React.useState(
    defaultDataSaveProgress,
  );

  const handleDateTimeModalOpen = () => setDateTimeModalOpen(true);
  const handleDateTimeModalClose = () => setDateTimeModalOpen(false);

  const handleLocationModalOpen = () => setLocationModalOpen(true);
  const handleLocationModalClose = () => setLocationModalOpen(false);

  const handleUpdate = async (isPublish = true) => {
    setSubmitting(true);

    const errors = {};
    if (!formValues.photo) {
      errors.photo = t("errors.required");
    }
    if (!Object.keys(formValues.eventCategory).length) {
      errors.eventCategory = t("errors.required");
    }
    if (!Object.keys(formValues.categories).length) {
      errors.categories = t("errors.required");
    }
    if (!formValues.eventName) {
      errors.eventName = t("errors.required");
    }
    if (!formValues.classDescription) {
      errors.classDescription = t("errors.required");
    } else if (formValues.classDescription.length < 5) {
      errors.classDescription = t("errors.aboutusMinLength", {
        businessName: title,
      });
    }
    if (!formValues.duration) {
      errors.duration = t("errors.required");
    }
    /* if (title === "Course" && !formValues.sessions) {
      errors.sessions = t("errors.required");
    } */
    if (formValues.freeCancellation) {
      if (!formValues.cancellationPeriod) {
        errors.cancellationPeriod = t("errors.required");
      }
    }
    if (!formValues.maxTicketsPerOrder || formValues.maxTicketsPerOrder <= 0) {
      errors.maxTicketsPerOrder = t("errors.required");
    }
    if (formValues.maxTicketsPerOrder % 1 !== 0) {
      errors.maxTicketsPerOrder = t("errors.decimalValueOnly");
    }
    setFormErrors({ ...errors });
    if (Object.keys(errors).length > 0) {
      setSubmitting(false);
      addErrorToast(t("errors.validationGeneralError"), { hideAfter: 3 });
      return;
    }

    const durationSplit = formValues.durationstring.split(" ");
    const durationInNum =
      Number(durationSplit[0]) * 60 + Number(durationSplit[2]);

    const cancelationPolicy =
      formValues.cancellationPeriod === "1hr"
        ? {
            isEnabled: true,
            text: "1 hour",
            minutes: 60,
            cancellationCharge: parseFloat(String(formValues.cancellationCharge).replace(",", ".")),
          }
        : formValues.cancellationPeriod === "24hrs"
          ? {
              isEnabled: true,
              text: "24 hours",
              minutes: 1440,
              cancellationCharge: parseFloat(String(formValues.cancellationCharge).replace(",", ".")),
            }
          : formValues.cancellationPeriod === "48hrs"
            ? {
                isEnabled: true,
                text: "48 hours",
                minutes: 2880,
                cancellationCharge: parseFloat(String(formValues.cancellationCharge).replace(",", ".")),
              }
            : formValues.cancellationPeriod === "1 week"
              ? {
                  isEnabled: true,
                  text: "1 week",
                  minutes: 10080,
                  cancellationCharge: parseFloat(String(formValues.cancellationCharge).replace(",", ".")),
                }
              : null;

    let body = {
      eventId: formValues.eventId,
      isPackage: profileFor === "course" ? true : false,
      eventCategory: formValues.eventCategory._id,
      catId: formValues.categories._id,
      eventType: formValues.categories.name,
      eventName: formValues.eventName,
      description: formValues.classDescription,
      tagLines: formValues.tagLine,
      duration: durationInNum,
      whatToCarry: formValues.whatToCarry,
      eventPhoto: formValues.photo,
      isPrivate: formValues.inviteCodeOnlyBooking,
      eventCancelationPolicy: formValues.freeCancellation
        ? cancelationPolicy
        : { isEnabled: false },
      maxTicketsPerOrder: parseInt(formValues.maxTicketsPerOrder),
      paymentAtVenue: formValues.paymentAtVenue,
      eventPricingList: formValues.eventPricingList,
      addonsPricingList: formValues.addonsPricingList,
      isPublic: isPublish,
    };

    if (!edit) {
      //add
    } else {
      body = {
        eventId: editData._id,
      };
    }
    let config = {};

    config = {
      method: "put",
      url: `${getUrlForEvent()}update`,
      data: body,
    };

    setDataSaveProgress((prevValues) => ({
      ...prevValues,
      isStartSubmiting: true,
    }));
    dispatch(setGlobalLoading(true));
    dispatch(setActionLoading(true));
    const request = await axiosInstance(config);
    dispatch(setGlobalLoading(false));
    dispatch(setActionLoading(false));

    if (request.status === 200) {
      if (request.data.statusCode === 200) {
        let eventData = request.data.data;
        setShowGeneralDrawer(false);
        setShowPoliciesDrawer(false);
        fetchScheduleDetails();
        setSubmitting(false);
        setDataSaveProgress((prevValues) => ({
          ...prevValues,
          isStartSubmiting: false,
        }));

        /** **/
        return;
      } else if (request.data.statusCode === 403) {
        addErrorToast(request.data.message);
        setSubmitting(false);
      }
    }
  };

  const handleScheduleUpdate = async () => {
    setSubmitting(true);

    // }
    // }

    let body = {
      // eventId: formValues.eventId,
      // scheduleId: sessionDataToDisplay?._id,
      eventScheduleId: sessionDataToDisplay?._id,
      eventPricingList: formValues.eventPricingList,
      addonsPricingList: formValues.addonsPricingList,
    };

    let config = {
      method: "put",
      url: `${getUrlForEvent()}schedule/update`,
      data: body,
    };

    setDataSaveProgress((prevValues) => ({
      ...prevValues,
      isStartSubmiting: true,
    }));
    dispatch(setGlobalLoading(true));
    dispatch(setActionLoading(true));
    const request = await axiosInstance(config);
    dispatch(setGlobalLoading(false));
    dispatch(setActionLoading(false));

    if (request.status === 200) {
      if (request.data.statusCode === 200) {
        let eventData = request.data.data;
        setShowGeneralDrawer(false);
        setShowPoliciesDrawer(false);
        fetchScheduleDetails();
        dispatch(
          dashboardActions.setUpdateSessionComp(
            dashboardReduxState.updateSessionComp + 1,
          ),
        );
        setSubmitting(false);
        setDataSaveProgress((prevValues) => ({
          ...prevValues,
          isStartSubmiting: false,
        }));

        /** **/
        return;
      } else if (request.data.statusCode === 403) {
        addErrorToast(request.data.message);
        setSubmitting(false);
      }
    }
  };
  const handleCancel = async (isPublish = true) => {};
  const clearFormValues = () => {
    setFormValues(classBodyData);
    setFormScheduleValues({});
  };

  const fetchScheduleDetails = async () => {
    const isPckg = sessionDataToDisplay.isPackage;
    const config = {
      method: "get",
      url: `${getUrlForEvent()}list?eventId=${eventInfo._id}&listFor=${userReduxState.businessType}`,
      // url: `${getUrlForEvent()}schedule/get?eventScheduleId=${sessionDataToDisplay._id}&isPackage=${isPckg}`,
    };
    dispatch(setGlobalLoading(true));
    const request = await axiosInstance(config);
    dispatch(setGlobalLoading(false));
    if (request.status === 200) {
      if (request.data.statusCode === 200) {

        // new event redux
        dispatch(dashboardActions.setEventData(request.data.data));
        dispatch(dashboardActions.setCalendarSessionId(request.data.data._id));
        // dispatch(dashboardActions.setEventScheduleData(request.data.data));
      }
    }
  };
  const onBackClick = () => {
    // navigate("/myevents", { replace: true });
    navigate("/myschedule/detail", { replace: true });
  };

  React.useEffect(() => {
    setDataSaveProgress(defaultDataSaveProgress);
    fetchScheduleDetails();
  }, []);

  React.useEffect(() => {
    const { eventDate, duration, eventEndDate } = sessionDataToDisplay;
    if (
      (sessionDataToDisplay?.eventDate &&
        moment(eventDate).subtract({ hours: 0 }).isBefore()) ||
      (sessionDataToDisplay?.eventStatus &&
        [/* 'Draft', 'Published',  */ "cancelled", "refunded"].indexOf(
          sessionDataToDisplay?.eventStatus?.toLowerCase(),
        ) > -1)
    ) {
      setPopoverOptionsDisabled(true);
    }
  }, [sessionDataToDisplay]);

  React.useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        (async () => {
          const userrequest = await axiosInstance({
            method: "get",
            url: `${getUrlForUsers()}getUserInfo`,
          });
          if (userrequest.data.statusCode === 200) {
            dispatch(
              userActions.setUserData({
                // ...userReduxState.userData,
                appUrl: userReduxState.userData.appUrl,
                ...userrequest.data.data,
              }),
            );
          }
        })();
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  React.useEffect(() => {
    (async () => {
      // const isPckg = dashboardReduxState.calendarClassData.isPackage;
      const isPckg = dashboardReduxState.eventScheduleData.isPackage;
      const config = {
        method: "get",
        url: `${getUrlForEvent()}schedule/get?eventScheduleId=${dashboardReduxState.eventScheduleId}&isPackage=${isPckg}`,
      };
      dispatch(setGlobalLoading(true));
      const request = await axiosInstance(config);
      dispatch(setGlobalLoading(false));
      if (request.status === 200) {
        if (request.data.statusCode === 200) {
          dispatch(dashboardActions.setEventData(request.data.data.eventId));
          dispatch(dashboardActions.setEventScheduleData(request.data.data));
        }
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dashboardReduxState.updateSessionComp]);

  return (
    <TwMainLayout
      headTitle={eventInfo.eventName}
      breadcrumbs={[
        {
          title: t("pageTitle.myEvents"),
          onClick: () => {
            navigate("/myschedule", { replace: true });
          },
        },
        {
          title: `${eventInfo.eventName}`,
          ...(sessionDataToDisplay?.eventStatus == "Published"
            ? {
                onClick: () => {
                  navigate("/myschedule/detail", { replace: true });
                },
              }
            : {}),
        },
        { title: t("inputFieldsTitle.edit") },
      ]}
      children={
        <TwContainer className="">
          <div className="flex flex-col w-full">
            <div className="flex flex-col gap-3 w-full">
              <div className="[flex] [flex-col sm:flex-row] grid grid-cols-1 sm:grid-cols-2 gap-8">
                <div className="flex flex-auto flex-col gap-2">
                  <div className={"w-full h-44 md:h-72 flex justify-center"}>
                    {eventInfo.eventPhoto ? (
                      <img
                        className={
                          // "w-full h-[283px] object-cover object-fill rounded-2xl"
                          // "sm:h-60 lg:h-72 rounded-2xl"
                          "w-full sm:h-60 lg:h-72 object-cover rounded-2xl border border-gray-200"
                        }
                        src={eventInfo.eventPhoto}
                        alt={""}
                      />
                    ) : (
                      <img
                        className={
                          "w-full sm:h-60 lg:h-72 object-cover rounded-2xl"
                        }
                        src={defaultImage}
                        alt={""}
                      />
                    )}
                  </div>
                </div>
                <div className="flex flex-auto flex-col gap-6 justify-center items-left ">
                  <div className="flex flex-col gap-6 justify-center items-left ">
                    {/* <div className="flex justify-start items-center w-full py-3">
                      <div className=" flex flex-col justify-start max-w-full sm:max-w-md mt-5">
                        <p className={"text-base font-extrabold"}>Share event Link</p>
                        <div className="flex justify-center items-center w-full mt-5 bg-list-hover rounded-2xl border border-gray-300">
                          <div className="max-h-6 flex-1 pl-2 text-black my-0 mx-5 truncate cursor-pointer"
                            onClick={() => {
                              navigator.clipboard.writeText(bookingLink);
                              addSuccessToast(t("myEvents.copied"));
                            }}
                          >
                            {bookingLink}
                          </div>
                          <div className="flex flex-none bg-primary py-2 px-5 rounded-e-2xl">
                            <button className="cursor-pointer" type="button" underline="none" onClick={() => {
                              navigator.clipboard.writeText(bookingLink);
                              addSuccessToast(t("myEvents.copied"));
                            }}>
                              <img
                                className={"w-5"}
                                src={copyOrange}
                                alt={""}
                              />
                            </button>
                            <button className="cursor-pointer" type="button" underline="none" target="_blank" onClick={() => {
                              window.open(bookingLink, '_blank');
                            }}>
                              <img
                                className={"w-5 ml-3 mr-3"}
                                src={shareOrange}
                                alt={""}
                              />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div> */}

                    <div className="flex justify-center items-center md:w-4/5">
                      <div className="flex-none">
                        <img className={""} src={greentime} alt={""} />
                      </div>
                      <div className="flex-1 pl-2">
                        <div className="text-gray-500 text-sm flex items-center gap-2">
                          {t("myEvents.eventDate")}
                          <button
                            disabled={popoverOptionsDisabled}
                            onClick={() => {
                              handleDateTimeModalOpen();
                            }}
                            className={`text-sm text-left hover:bg-gray-200 rounded-md p-2 ${popoverOptionsDisabled && "hidden"}`}
                          >
                            <EditPencilIcon className="!text-secondary" />
                          </button>
                        </div>
                        <div className="text-black text-base">
                          {sessionDataToDisplay.eventDate
                            ? format(
                                parseISO(sessionDataToDisplay.eventDate),
                                "EEEE, MMMM d 'at' HH:mm",
                              ) +
                              " - " +
                              format(
                                parseISO(sessionDataToDisplay?.eventEndDate),
                                "HH:mm",
                              )
                            : ""}
                        </div>
                        <div className="text-gray-500 text-xs">
                          {sessionDataToDisplay?.allEventSchedules &&
                          sessionDataToDisplay?.allEventSchedules.length > 1
                            ? t("myEvents.eventDate")
                            : ""}
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-center items-start md:w-4/5">
                      <div className="flex-none">
                        <img className={""} src={greenlocation} alt={""} />
                      </div>
                      <div className="flex-1 pl-2">
                        <div className="text-gray-500 text-sm flex items-center gap-2">
                          {t("myEvents.venue")}
                          <button
                            disabled={popoverOptionsDisabled}
                            onClick={() => {
                              handleLocationModalOpen();
                            }}
                            className={`text-sm text-left hover:bg-gray-200 rounded-md p-2 ${popoverOptionsDisabled && "hidden"}`}
                          >
                            <EditPencilIcon className="!text-secondary" />
                          </button>
                        </div>
                        <div className="text-black text-base">
                          <p className="font-bold">
                            {sessionDataToDisplay &&
                            sessionDataToDisplay?.location
                              ? sessionDataToDisplay?.location.addressName
                              : ""}
                          </p>
                          <p>
                            {sessionDataToDisplay &&
                            sessionDataToDisplay?.location
                              ? sessionDataToDisplay?.location.address
                              : ""}
                          </p>
                        </div>
                      </div>
                    </div>
                    {/* <div className="w-full flex flex-col sm:flex-row gap-2 items-center py-3">
                    <StatBox {...{
                      id: "Revenue",
                      title: t("myEvents.revenue"),
                      data: eventInfo?.totalBookings?.totalRevenue ? eventInfo?.totalBookings?.totalRevenue : 0,
                      bgColor: "bg-lilac",
                      icon: clock_png,
                      update: "",
                    }} />
                    <StatBox {...{
                      id: t("myEvents.ticketsBooked")},
                      title: t("myEvents.ticketsBooked")},
                      data: eventInfo?.totalBookings?.totalConfirmedBooking ? eventInfo?.totalBookings?.totalConfirmedBooking : 0,
                      bgColor: "bg-secondary",
                      icon: clock_png,
                      update: "",
                    }} />
                  </div> */}
                  </div>
                </div>
              </div>
              <div className="flex flex-col gap-5 w-full py-2">
                <div className="p-5 border-2 border-bright-gray hover:border-primary rounded-lg">
                  <div className={"flex flex-col gap-2"}>
                    <div className={"flex gap-2 w-full"}>
                      <div className={"w-full flex flex-col grow gap-2"}>
                        <h2
                          className={"font-bold text-xl sm:text-3xl [truncate]"}
                        >
                          {eventInfo.eventName}
                        </h2>
                        <p className={"text-sm sm:text-base"}>
                          {eventInfo.tagLines}
                        </p>
                        <div className={"flex flex-row items-start gap-2"}>
                          <TwRating rating={eventInfo.rating} />
                        </div>
                        <div className={"w-auto flex"}>
                          <span
                            className={
                              "w-auto flex rounded-lg py-0.5 px-1 text-sm bg-[#323232] text-white"
                            }
                          >
                            {" "}
                            {eventInfo.duration > 60
                              ? `${durationObj.hours} hr ${durationObj.mins} min`
                              : `${eventInfo.duration} minutes`}
                          </span>
                        </div>
                        <p className={"text-base text-secondary"}>
                          {" "}
                          {sessionDataToDisplay?.eventStatus &&
                          [
                            /* 'Draft', 'Published',  */ "cancelled",
                            "refunded",
                          ].indexOf(
                            sessionDataToDisplay?.eventStatus?.toLowerCase(),
                          ) > -1
                            ? t("myEvents.classInstanceIsCancelled")
                            : ""}
                        </p>
                      </div>
                      <div className="flex-auto ">
                        <TwButton
                          variant={"default-box"}
                          className="truncate"
                          onClick={() => {
                            setShowGeneralDrawer(true);
                          }}
                        >
                          <EditPencilIcon />
                          &nbsp;&nbsp;{t("myEvents.editBasicInfo")}
                        </TwButton>
                      </div>
                    </div>

                    <div>
                      <h4 className={"font-bold text-lg"}>
                        {t("myEvents.description")}
                      </h4>
                      <p
                        className={"font-light text-base"}
                        dangerouslySetInnerHTML={{
                          __html: eventInfo.description,
                        }}
                      ></p>
                      <p className={"hidden font-light text-base"}>
                        {/* {eventInfo.description?.length > 175 ? (
                        !isDescExpanded ? (
                          <>
                            {eventInfo.description.slice(0, 175)}
                            <span
                              className={
                                "text-gray-400 font-light text-base cursor-pointer"
                              }
                              onClick={() => setDescExpanded(true)}
                            >
                              {t("myEvents.seeMore")}
                            </span>
                          </>
                        ) : (
                          <span>
                            {eventInfo.description}
                            <br />
                            <span
                              className={
                                "text-gray-400 font-light text-base cursor-pointer"
                              }
                              onClick={() => setDescExpanded(false)}
                            >
                              see less
                            </span>
                          </span>
                        )
                      ) : (
                        <span>{eventInfo.description}</span>
                      )} */}
                      </p>
                    </div>
                    {/* <div>
                    <h4 className={"font-bold text-lg"}>
                      {t("myEvents.whatToCarry")}
                    </h4>
                    <p className={"font-light text-base"}>
                      {eventInfo.whatToCarry?.length > 175 ? (
                        !isWhatToCarryExpanded ? (
                          <>
                            {eventInfo.whatToCarry.slice(0, 175)}
                            <span
                              className={
                                "text-gray-400 font-light text-base cursor-pointer"
                              }
                              onClick={() => setWhatToCarryExpanded(true)}
                            >
                              {t("myEvents.seeMore")}
                            </span>
                          </>
                        ) : (
                          <span>
                            {eventInfo.whatToCarry}
                            <br />
                            <span
                              className={
                                "text-gray-400 font-light text-base cursor-pointer"
                              }
                              onClick={() => setWhatToCarryExpanded(false)}
                            >
                              see less
                            </span>
                          </span>
                        )
                      ) : (
                        <span>{eventInfo.whatToCarry}</span>
                      )}
                    </p>
                  </div> */}
                  </div>
                </div>
                <div className="p-5 border-2 border-bright-gray hover:border-primary rounded-lg flex flex-col gap-6">
                  <div className={"flex w-full gap-2"}>
                    <div className="items-left w-full text-2xl sm:text-3xl">
                      {t("myEvents.eventSettings")}
                    </div>
                    <div>
                      <TwButton
                        variant={"default-box"}
                        className="truncate"
                        onClick={() => {
                          setShowPoliciesDrawer(true);
                        }}
                      >
                        <EditPencilIcon />
                        &nbsp;&nbsp;{t("myEvents.editSettings")}
                      </TwButton>
                    </div>
                  </div>

                  <div className={"flex-1"}>
                    <h4 className={"font-bold text-lg"}>
                      {t("myEvents.cancellationPolicyTitle")}
                    </h4>
                    {eventInfo?.eventCancelationPolicy?.isEnabled ? (
                      <p className={"font-light text-base"}>
                        {/* Cancelation is free in case booking is cancelled{" "}
                      <span className={"font-bold"}>
                        {eventInfo.eventCancelationPolicy.text}
                      </span>{" "}
                      before start of the event. */}
                        {t("myEvents.cancellationPolicyMsg1")}{" "}
                        <span className={"font-bold"}>
                          €
                          {eventInfo.eventCancelationPolicy?.cancellationCharge
                            ? i18n.language === "nl"
                              ? String(eventInfo.eventCancelationPolicy?.cancellationCharge || "").replace(
                                  ".",
                                  ",",
                                )
                              : eventInfo.eventCancelationPolicy
                                  ?.cancellationCharge
                            : 0}
                        </span>{" "}
                        {t("myEvents.cancellationPolicyMsg2")}{" "}
                        <span className={"font-bold"}>
                          {eventInfo.eventCancelationPolicy.text}
                        </span>{" "}
                        {t("myEvents.cancellationPolicyMsg3")}
                      </p>
                    ) : (
                      <p className={"font-light text-base"}>
                        {t("myEvents.freeCancelationNotAvailable")}
                      </p>
                    )}
                  </div>
                  {/* <div>
                  <h4 className={"font-bold text-lg"}>
                    {t("myEvents.payAtVenue")}
                  </h4>
                  {eventInfo?.eventCancelationPolicy?.isEnabled ? (
                    <p className={"font-light text-base"}>
                      Pay at venue is {((eventInfo?.paymentAtVenue && eventInfo?.paymentAtVenue === false)) ? "not " : ""}available for this class.
                    </p>
                  ) : (
                    <p className={"font-light text-base"}>
                      {t("myEvents.freeCancelationNotAvailable")}
                    </p>
                  )}
                </div> */}
                  <div>
                    <h4 className={"font-bold text-lg"}>
                      {t("myEvents.maxTicketsPerOrderTitle")}
                    </h4>
                    {eventInfo?.maxTicketsPerOrder != undefined &&
                    eventInfo?.maxTicketsPerOrder !== 1000 ? (
                      <p className={"font-light text-base"}>
                        {t("myEvents.maxTicketsPerOrderMsg1")}{" "}
                        <span className="font-bold">
                          {eventInfo?.maxTicketsPerOrder}
                        </span>{" "}
                        {t("myEvents.maxTicketsPerOrderMsg2")}
                      </p>
                    ) : (
                      <p className={"font-light text-base"}>
                        {t("myEvents.noLimitInSingleOrder")}
                      </p>
                    )}
                  </div>
                  {eventInfo?.bookingCode ? (
                    <div>
                      <h4 className={"font-bold text-lg"}>
                        {t("myEvents.bookingOnlyByInviteCode")}
                      </h4>
                      <p
                        className={
                          "font-light text-base flex items-center gap-2"
                        }
                      >
                        {t("myEvents.invitecode")}{" "}
                        <b>{eventInfo?.bookingCode || ""}</b>
                        <span
                          className={"inline-block items-center cursor-pointer"}
                          onClick={async () => {
                            try {
                              await navigator.clipboard.writeText(
                                eventInfo?.bookingCode,
                              );
                              addSuccessToast(t("myEvents.copied"));
                            } catch (e) {
                              addErrorToast(t("myEvents.failedToCopy"));
                            }
                          }}
                        >
                          <img
                            src={copy_squares}
                            alt={t("myEvents.copy")}
                            title={t("myEvents.copy")}
                          />
                        </span>
                      </p>
                    </div>
                  ) : (
                    <div>
                      <h4 className={"font-bold text-xl "}>
                        {formValues.inviteCodeOnlyBooking
                          ? t("myEvents.privateEventStatus")
                          : t("myEvents.publicEventStatus")}
                      </h4>
                      <p className={"text-sm text-gray-500"}>
                        {t("myEvents.eventCanBookedByAnybody")}
                      </p>
                    </div>
                  )}
                </div>

                <div className="p-5 border-2 border-bright-gray hover:border-primary rounded-lg">
                  {/* <div className="items-left w-full text-2xl sm:text-3xl">
                  {t("myEvents.eventTickets")}
                </div> */}
                  <div>
                    <PricingTab
                      edit={true}
                      profileFor={profileFor}
                      formValues={formValues}
                      setFormValues={setFormValues}
                      setTabCurrentState={setTabCurrentState}
                      // handleUpdate={handleUpdate}
                      handleUpdate={handleScheduleUpdate}
                      isFromDetail={true}
                      scheduleCreatAtDateTime={moment().unix()}
                      scheduleStartDateTime={moment(
                        sessionDataToDisplay.eventDate,
                      ).unix()}
                      scheduleEndDateTime={moment(
                        sessionDataToDisplay?.eventEndDate,
                      ).unix()}
                    />
                  </div>
                </div>

                <div className="p-5 border-2 border-bright-gray hover:border-primary rounded-lg">
                  {/* <div className="items-left w-full text-2xl sm:text-3xl" sx={{ fontSize: 25 }}>
                  {t("myEvents.eventAddons")}
                </div> */}
                  <div>
                    <AddonsTab
                      edit={true}
                      profileFor={profileFor}
                      formValues={formValues}
                      setFormValues={setFormValues}
                      setTabCurrentState={setTabCurrentState}
                      // handleUpdate={handleUpdate}
                      handleUpdate={handleScheduleUpdate}
                      isFromDetail={true}
                    />
                  </div>
                </div>

                <div className="p-5 border-2 border-bright-gray hover:border-primary rounded-lg">
                  <div>
                    <SalesChannleTab
                      edit={true}
                      eventScheduleData={sessionDataToDisplay}
                      formValues={{
                        salesChannelList: sessionDataToDisplay.salesChannelList,
                      }}
                      // setFormValues={setFormValues}
                      setTabCurrentState={setTabCurrentState}
                      handleUpdate={handleUpdate}
                      isFromDetail={true}
                    />
                  </div>
                </div>

                {false && (
                  <div className="p-5 border-2 border-bright-gray hover:border-primary rounded-lg">
                    <ScheduleTab
                      edit={true}
                      reloadScheduleDetails={fetchScheduleDetails}
                      duration={formValues.duration}
                      classObj={formValues}
                      eventFormValues={formValues}
                      setEventFormValues={setFormValues}
                      formErrors={formErrors}
                      formScheduleValues={formScheduleValues}
                      setFormScheduleValues={setFormScheduleValues}
                      setTabCurrentState={setTabCurrentState}
                      defaultDataSaveProgress={defaultDataSaveProgress}
                      dataSaveProgress={dataSaveProgress}
                      setDataSaveProgress={setDataSaveProgress}
                      defaultScheduleData={defaultScheduleData}
                      setDefaultScheduleData={setDefaultScheduleData}
                      isFromDetail={true}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <TwDrawer
            open={showGeneralDrawer}
            showXBtn={false}
            onClose={() => {
              setShowGeneralDrawer(false);
            }}
            classNameDialogPanel={`!max-w-3xl`}
          >
            <div className={""}>
              <GeneralTab
                profileFor={profileFor}
                title={title}
                edit={true}
                formValues={formValues}
                setFormValues={setFormValues}
                formValidationErrors={formErrors}
                setTabCurrentState={setTabCurrentState}
                handleUpdate={handleUpdate}
                handleCancel={() => {
                  // alert("cancel");
                  setShowGeneralDrawer(false);
                }}
              />
            </div>
          </TwDrawer>
          <TwDrawer
            open={showPoliciesDrawer}
            showXBtn={false}
            onClose={() => {
              setShowPoliciesDrawer(false);
            }}
            classNameDialogPanel={`!max-w-2xl`}
          >
            <div className={""}>
              <PoliciesTab
                edit={true}
                formErrors={formErrors}
                formValues={formValues}
                handleFormValueChange={handleFormValueChange}
                setFormValues={setFormValues}
                setTabCurrentState={setTabCurrentState}
                payment={payment}
                handleUpdate={handleUpdate}
                handleCancel={() => {
                  setShowPoliciesDrawer(false);
                }}
                isFromDetail={true}
              />
            </div>
          </TwDrawer>

          <ChangeDateTimeModal
            open={dateTimeModalOpen}
            handleClose={handleDateTimeModalClose}
            sessionData={sessionDataToDisplay}
            instanceId={sessionDataToDisplay && sessionDataToDisplay?._id}
            handleUpdate={() =>
              dispatch(
                dashboardActions.setUpdateSessionComp(
                  dashboardReduxState.updateSessionComp + 1,
                ),
              )
            }
          />
          <ChangeLocationModal
            open={locationModalOpen}
            handleClose={handleLocationModalClose}
            sessionData={sessionDataToDisplay}
            instanceId={sessionDataToDisplay._id}
            handleUpdate={() =>
              dispatch(
                dashboardActions.setUpdateSessionComp(
                  dashboardReduxState.updateSessionComp + 1,
                ),
              )
            }
          />
        </TwContainer>
      }
    />
  );
}
